import { ReactNode } from 'react';
import { EarningMechanismFragment } from '@occc/graphql';
import { awardHelper } from '@occc-app/offerHelpers/utils/awardHelper';
import { routeCreator as productGroupRouteCreator } from '@occc-app/routes/ProductGroup/utils';

import { pluralize } from '@occc-app/lib/strings';
import { ItemsOrViewAll } from '../../../components';
import { isVarietyDiscount } from '../configuration-section.utils';

export const getVarietyDiscountBlocks = (
  earningMechanism?: EarningMechanismFragment | null,
): ReactNode[] => {
  if (!isVarietyDiscount(earningMechanism)) {
    return [];
  }

  const blocks: ReactNode[] = [];

  if (awardHelper.isProductDiscountAward(earningMechanism.varietyDiscountAward)) {
    const awardProductGroups = earningMechanism.varietyDiscountAward.eligibleProductGroups.map(
      (pg) => ({
        id: pg.id,
        label: pg.name,
        href: productGroupRouteCreator.details(pg.id),
      }),
    );

    blocks.push(
      <ItemsOrViewAll
        label='Discount Product Groups'
        itemName='Product Group'
        items={awardProductGroups}
      />,
    );
  }

  earningMechanism.purchases.forEach((purchase) => {
    const productGroups = purchase.eligibleProductGroups.map((pg) => ({
      id: pg.id,
      label: pg.name,
      href: productGroupRouteCreator.details(pg.id),
    }));

    blocks.push(
      <ItemsOrViewAll
        label='Purchase Threshold'
        value={`${purchase.purchaseThreshold} ${pluralize(purchase.purchaseThreshold, 'item')}`}
        itemName='Product Group'
        items={productGroups}
      />,
    );
  });

  return blocks;
};
